function IGAuth () {
  var self = this

  self.openGetCodePage = function (fbClientID, redirectUri, jwtToken, scope) {
    return new Promise((resolve, reject) => {
      // const version = 'v9.0'
      let scopeURL = scope ? '&scope=' + scope : ''
      let url = `https://api.instagram.com/oauth/authorize?client_id=${fbClientID}&redirect_uri=${redirectUri}&response_type=code&state=${jwtToken}${scopeURL}`

      window.handleIGLoginResult = (eventData, error) => {
        console.log(`handleIGLoginResult`, eventData, error)
        if (error) {
          if (error.includes('錯誤的帳號，請登入指定的IG帳號')) {
            alert('錯誤的帳號，請登入指定的IG帳號')
          }
          reject(error)
        } else {
          resolve(eventData)
        }
      }
      window.open(url)
    })
  }
}

window.addEventListener('message', (event) => {
  let message = event.data.message
  // let expiredAt = event.data.expiredAt
  let error = event.data.error
  if (message === 'ig-oauth-event' && typeof window.handleIGLoginResult === 'function') {
    window.handleIGLoginResult(event.data, error)
  }
})
export default new IGAuth()
